import React, { useState } from "react";
import Model from "./ModelNew";

import tw from "tailwind-styled-components";

const ContactDetailsModal = ({ setOpenContactModel }) => {
  return (
    <Model width={"w-11/12 max-w-xl"} setOpenModel={setOpenContactModel} title="Contact Us">
      <>
        {/* <Title>Contact Details</Title>

        <div className="w-full  items-center  mt-4">
          <Heading> Feel free to get in touch with us.</Heading>
          <SubHeading>
            You can directly mail your query to info@sars.com or call on +255
            272 747 529
          </SubHeading>
        </div> */}
        <Wrapper>
        <SingleItem name={"ABEL ODENA"}  designation={"REGISTRATION OFFICER"} value={"+255 762 469 382"} />
        <SingleItem name={"BAHATI MSOFE"} designation={"HICT"} value={"+255 784 168 417"} />
        <SingleItem name={"NAJAHA BAKARI"} designation={"PR OFFICER"} value={"+255 786 883 991"} />
        </Wrapper>

        {/* <Content>
          <ContactInfo>
            <Heading>Company Information</Heading>
            <InfoItem>
              <strong>Email:</strong> sars@nationalsportscouncil.go.tz
            </InfoItem>
            <InfoItem>
              <strong>Phone:</strong> +255 762469382 or +255 743790069
            </InfoItem>
          </ContactInfo>
          <ContactOptions>
            <Heading>Contact Options</Heading>
            <SubHeading>
              Feel free to get in touch with us. You can directly mail your
              query to{" "}
              <a
                className="!text-gray-600 !underline hover:!text-blue-500 "
                href="mailto:sars@nationalsportscouncil.go.tz"
              >
                sars@nationalsportscouncil.go.tz
              </a>{" "}
              or call on{" "}
              <a
                className="!text-gray-600 hover:underline"
                href="tel:+255762469382"
              >
                +255 762469382
              </a>{" "}
              or
              <a
                className="!text-gray-600 hover:underline"
                href="tel:+255743790069"
              >
                +255 743790069
              </a>{" "}
            </SubHeading>
          </ContactOptions>
        </Content> */}
      </>
    </Model>
  );
};

const SingleItem = ({ name, designation, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <div className="flex-row">
    <Name>{name}</Name> 
    <Designation>{designation}</Designation> 
    </div>
    <p className="w-8">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4 mb-4`;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const Name = tw.p`text-base text-gray-800  w-72`;
const Designation = tw.p`text-xs text-gray-500  w-72`;
const Value = tw.p`text-base text-gray-800 font-medium max-w-xs `;

const Container = tw.div`p-8`;
const Title = tw.h2`text-2xl font-bold mb-4 text-gray-800 text-center mr-3`;
const Content = tw.div`flex flex-wrap -mx-4`;
const ContactInfo = tw.div`w-full md:w-1/2 px-4 mb-5`;
const ContactOptions = tw.div`w-full md:w-1/2 px-4 mb-5`;
const Heading = tw.h3`text-xl font-bold mb-4 text-gray-800`;
const SubHeading = tw.p`mb-4 text-gray-600`;
const InfoItem = tw.p`mb-3 text-gray-800`;
const Button = tw.button`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600`;
// const Title = tw.h2` text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Delete = tw.button`px-8 py-3 text-sm bg-red-500 text-white rounded hover:bg-red-600`;
const Cancel = tw.button`px-8 py-3 text-sm bg-gray-100 text-gray-600 rounded hover:bg-gray-200`;
// const Heading = tw.h3`text-xl text-gray-500 font-normal`;
// const SubHeading = tw.h3`text-lg text-gray-500 font-normal`;
export default ContactDetailsModal;
